const boltColor = [
  {
    id: 1,
    type: "shootBoltColor",
    label: "Bronze",
  },
  {
    id: 2,
    type: "shootBoltColor",
    label: "Brushed Chrome",
  },
  {
    id: 3,
    type: "shootBoltColor",
    label: "Black",
  },
  {
    id: 4,
    type: "shootBoltColor",
    label: "White",
  },
];

const picoBoltColor = [
  {
    id: 1,
    type: "shootBoltColor",
    label: "Black",
  },
  {
    id: 2,
    type: "shootBoltColor",
    label: "Stainless Steel",
  },
];

const alumBifoldBoltColor = [
  {
    id: 1,
    type: "shootBoltColor",
    label: "Black",
  },
  {
    id: 2,
    type: "shootBoltColor",
    label: "Dark Silver",
  },
];

export { boltColor, picoBoltColor, alumBifoldBoltColor };
